import { TableHeadingCell, withTableHeadingAccessibility } from './TableHeadingCell';
export var TableColumnHeadingCell = withTableHeadingAccessibility(TableHeadingCell, {
  role: 'columnheader',
  scope: 'col',
  displayName: 'TableColumnHeadingCell'
});